export interface CHRFilterReduxState {
    onlyUserCHR: boolean
}

export const DEFAULT_CHR_FILTER_STATE: CHRFilterReduxState = {
    onlyUserCHR: true,
}
